<template>
	<div class="containerPage">
		<div class="coninfo" style="width: 800px;height: 506px;">
			<div>
				<el-steps :active="active" finish-status="success" style="margin-left: 15px;  width: 800px;">
					<el-step title="Submission"></el-step>
					<el-step title="Contract Preparation"></el-step>
					<el-step title="Contract Signing"></el-step>
				</el-steps>
				<!-- <el-button @click="next">下一步</el-button> -->
				<div v-if="active==0" style="min-height: 320px;">
					<div style="display: flex;align-items: center;justify-content: center;">
						<img style="height:110px;" src="../../assets/img/tipPicture.png" alt="" />
					</div>
					<div style="font-size:20px;  text-align:center;">Your contract application 
						has been submitted.</div>
					<div style="margin-top: 5px; font-size:15px; text-align:center;">Your contract application 
						submitted at {{applyTime}}（UTC+0） is under review.
						A decision will be made within 14 working days.
					</div>
				</div>

				<div v-if="active==1" style="min-height: 320px;">
					<div style="display: flex;align-items: center;justify-content: center;">
						<img src="../../assets/img/tip.png" alt="" />
					</div>

					<div style="font-size:20px;  text-align:center;">Your contract application was
						not approved</div>
					<div style=" font-size:15px; text-align:center;">We are sorry to inform you that
						your contract application submitted at {{applyTime}}（UTC+0） was not approved.Please review our
						feedback below.</div>

					<div class="tipBox">
						{{refuseReason}}
					</div>

				</div>


				<div v-if="active==2"
					style="min-height: 320px;display: flex;align-items: center;justify-content: center;">
					<div style="text-align:center;font-size: 42px;line-height: 50px;color: black;">
						Your editor would contact you to
						proceed furthur.
					</div>
				
				</div>
			</div>
			<div v-if="active==3" style="min-height: 340px;">

			</div>
			<div style="padding-left:340px">
				<el-button type="primary" plain @click="toMystory">My story</el-button>
				<el-button type="primary" @click="tosigning()" v-if="active===1">Reapply</el-button>
			</div>
		</div>
	</div>
	</div>

</template>

<script>
	import {
		Date
	} from 'core-js';
	import {
		getAuthorContractServiceInfo,
		getAuthorGuarantorServiceInfo,
		getAuthorUserbyId,
		updateAuthorUserInfoNotNull,
		updateAuthorGuarantorServiceInfo,
		updateAuthorContractServiceInfo,
	} from '../../common/api/authorUser.js'
	
	
	import {
		getAuthorWorksInfo,
	} from '../../common/api/works.js'

	export default {
		data() {
			return {
				active: 0,
				refuseReason:"",
				applyTime: "",
				workinfo:{},
			};
		},
		created() {
			let query = JSON.parse(this.$route.query.params)
			this.userInfo = this.$store.state.userInfo
			this.bookId = query.bookId
			//this.utctime = this.formatDate(Date.now())
			this. getAuthorWorksInfo() 
		},
		methods: {
			next() {
				console.log("this.active", this.active)
				if (this.active++ > 2) this.active = 0;
				//this.active=2
			},
			onback() {
				this.$router.back()
			},
			/* formatDate(Time) { //获得UTC的时间
				const moment = require('moment-timezone');

				if (Time == null) {
					return null
				}
				var timezone = "Asia/Shanghai";
				const clean = moment(Time).format('YYYY-MM-DD HH:mm:ss'); // 清除 timezone 信息
				const Shanghailocal = moment.tz(clean, timezone);
				return Shanghailocal.tz('UTC').format('YYYY-MM-DD HH:mm:ss')
			}, */
			//去作品签署设定
			tosigning(item) {
				console.log('this.workinfo', this.workinfo);
				
				this.$router.push({
					path: '/work/signingManagement',
					query: {
						params: JSON.stringify({
							bookId: this.workinfo.id,
							isOperator: this.isOperator
						})
					}
				})
			},
			
			toMystory() {
				this.$router.back()
			},
			async getAuthorWorksInfo() {
				let data = {
					data: {
						id: this.bookId
					}
				}
				
				const res=await getAuthorWorksInfo(data)
				if (res.code == 0) {
					this.workinfo = res.data
					this.setActive(this.workinfo)
					console.log("workinfo",this.workinfo)
				} 
				
			},
			setActive(work){
				if(work==null)return 
				
				const applyUtctime=work.applyTime.replace("T"," ")
				if(work.signStatus==100){//默认状态
					this.active=0
					this.refuseReason=work.refuseReason
					this.applyTime=applyUtctime
				}
				else if(work.signStatus==1){//签约通过
					this.active=2
					this.refuseReason=work.refuseReason
					this.applyTime=applyUtctime
					
				}
				else if(work.signStatus==2){//签约不通过
					this.active=1
					this.refuseReason=work.refuseReason
					this.applyTime=applyUtctime
					
				}
				else if(work.signStatus==3){//签约中
					this.active=0
					this.refuseReason=work.refuseReason
					this.applyTime=applyUtctime
					
				}
				console.log("this.active",this.active)
				
			}
			
		},
	}
</script>
<style lang="scss" scoped>
	.containerPage {
		display: flex;
		align-items: center;
		justify-content: center;

		.tipBox {
			margin: 30px 0;
			padding: 10px 20px;
			background-color: #FFF5F5;
			color: red;

		}
	}

	/deep/.el-steps .el-step:first-child .el-step__head::before {
		display: none;
	}

	/deep/ .el-steps .el-step:last-child .el-step__head::before {
		display: none;
	}

	/deep/ .el-steps .el-step:last-child .is-process::before {
		display: none;
	}

	/deep/.el-steps .el-step__head.is-process .is-text {
		width: 42px;
		height: 42px;
		border-radius: 50%;
		background-color: #2474F8;
		position: relative;
		z-index: 99;
		border: 5px solid #D1E2FC;



	}

	/deep/.el-step__icon-inner {
		color: #ffffff;
		font-size: 18px;
		z-index: 100;
	}

	/deep/.el-step.is-horizontal .el-step__line {
		top: 25px !important;
		background-color: #2474F8;
		/*虚线2 css*/
		background: linear-gradient(to left, transparent 0%, transparent 50%, #2474F8 50%, #2474F8 100%);
		background-size: 15px 2px;
		background-repeat: repeat-x;
		z-index: 1;

	}


	/deep/.el-steps .el-step__head.is-wait .is-text {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: #fff;
		border: 2px dashed #2474F8;
		position: relative;

		.el-step__icon-inner {
			color: #2474F8;
		}

		// &::after {
		// 	position: absolute;
		// 	width: 45px;
		// 	height: 45px;
		// 	border-radius: 50%;
		// 	content: '';
		// 	border: 5px solid #fff;
		// }
	}

	/deep/ .el-step__head.is-process {
		height: 55px;
		display: flex;
		align-items: center;
	}

	/deep/ .el-step__head.is-wait {
		height: 55px;
		display: flex;
		align-items: center;
	}

	/deep/ .el-step__head.is-success {
		height: 55px;
		display: flex;
		align-items: center;
	}

	/deep/.el-steps .el-step__head.is-success .is-text {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: #fff;
		border: 2px dashed #2474F8;
		position: relative;

		.el-step__icon-inner {
			color: #2474F8;
		}

		// &::after {
		// 	position: absolute;
		// 	width: 45px;
		// 	height: 45px;
		// 	border-radius: 50%;
		// 	content: '';
		// 	border: 5px solid #fff;
		// }

	}

	/deep/.el-step__title.is-process {
		margin-left: -35px;

	}

	/deep/.el-step__title.is-wait {
		margin-left: -42px;

	}

	/deep/.el-step__title.is-success {
		margin-left: -35px;

	}
</style>